import script from "./faqView.vue?vue&type=script&setup=true&lang=js"
export * from "./faqView.vue?vue&type=script&setup=true&lang=js"

import "./faqView.vue?vue&type=style&index=0&id=02a2bb40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a2bb40"]])

export default __exports__